import BansheeMediaQuery from './src/MediaQuery'

BansheeMediaQuery.install = function (Vue) {
  Vue.component(BansheeMediaQuery.name, BansheeMediaQuery)
}

export default BansheeMediaQuery
